// istanbul ignore file

import * as yup from '@cld/yup-extra';

export const cookbookRecipeCategorySchema = yup
  .object({
    id: yup.number().required(),
    name: yup.string().required(),
  })
  .required();

export type CookbookRecipeCategory = yup.InferType<typeof cookbookRecipeCategorySchema>;

export const cookbookRecipeCategoryDtoSchema = cookbookRecipeCategorySchema
  .shape({
    recipesCount: yup.number().required(),
  })
  .required();

export type CookbookRecipeCategoryDto = yup.InferType<typeof cookbookRecipeCategoryDtoSchema>;
